const GET_PRIVATE_PROFILE_USER_QUERY = `
  query GetPrivateProfileUserQuery {
    me {
      getUserInfo {
        id
        isAdmin
        isVerified
        nickname
        image {
          id
          url(width: 60, height: 60)
        }
        createdAt
        totalComments
        totalOffers
        maxTemperature
        totalCommentLikes
        totalFollowedUsers
        totalUsersFollowing
        totalCommentReactions {
          like
          funny
          helpful
        }
      }
    }
  }
`;

export default GET_PRIVATE_PROFILE_USER_QUERY;
